<template>
  <div>
    <ul class="tab">
      <li class="tab-item" :class="{'tab-item-current':current==0}" @click="changeTab(0)">本周课表</li>
      <li class="tab-item" :class="{'tab-item-current':current==1}" @click="changeTab(1)">下周课表</li>
    </ul>
    <div class="tab-content">
      <ul class="weekdates">
        <li
          class="weekdate"
          :class="{'weekdate-current':weekday==index+1}"
          v-for="(weekDate,index) in weekDateList"
          :key="index"
          @click="changeWeek(index+1)"
        >
          {{weeks[index]}}
          <br />
          {{weekDate}}
        </li>
      </ul>
      <div class="type-title" v-if="courses.length">班课</div>
      <ul class="course-list" v-if="courses.length">
        <li class="course-item" v-for="(course,index) in courses" :key="index">
          <span class="course-time">{{course.start_play_time+"-"+course.end_play_time}}</span>
          <span class="course-type">{{course.course_type_name}}</span>
          <span class="course-main" v-if="course.course_type!=4">
            <span class="course-title">{{course.chapter_title}}</span>
            <br />
            <span>{{"来自课程《"+course.title+"》"}}</span>
          </span>
          <span class="course-main" v-else>
            <span class="course-title">{{course.title}}</span>
          </span>
          <span class="course-teacher" :title="course.teacher">{{course.teacher}}</span>
          <span class="course-state">{{course.state}}</span>
        </li>
      </ul>
      <div class="type-title" v-if="otoCourses.length">
        一对一约课
        <span style="color:#999999;margin-left:100px;">
          <span class="sp-appoint-exam sp-appoint-has"></span>
          <span style="margin-left:15px;">已约</span>
          <span class="sp-appoint-exam sp-appoint-none" style="margin-left:45px;"></span>
          <span style="margin-left:15px;">未约</span>
        </span>
      </div>
      <ul class="course-list" v-if="otoCourses.length">
        <li class="course-item" v-for="(course,index) in otoCourses" :key="index">
          <span class="course-time">{{course.start_play_time+"-"+course.end_play_time}}</span>
          <div>
            <span
              v-for="(teacher,index) in course.teacher_list"
              :key="index"
              class="sp-appoint"
              :title="teacher.teacher_name"
              :class="teacher.user_id==0?'sp-appoint-none':'sp-appoint-has'"
            >{{teacher.teacher_name||"&nbsp;"}}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as enums from "../../utils/enums";

export default {
  name: "TeachOtoTable",
  data() {
    return {
      current: 0,
      weekday: 1,
      weeks: {
        0: "周一",
        1: "周二",
        2: "周三",
        3: "周四",
        4: "周五",
        5: "周六",
        6: "周日"
      },
      weekDateList: [],
      courses: [],
      otoCourses: []
    };
  },
  async created() {
    let weekday = new Date().getDay();
    if (weekday == 0) {
      weekday = 7;
    }
    this.weekday = weekday;
    await this.getData();
  },
  methods: {
    async getData() {
      let data = await this.$http.get(
        "/api/course/schedule/" + this.weekday + "/" + this.current
      );
      this.weekDateList = data.weekDateList;
      let courses = data.courseList;
      let currentTime = parseInt(new Date().getTime() / 1000);
      courses.forEach(c => {
        c.start_play_time = new Date(c.start_play * 1000).format("hh:mm");
        c.end_play_time = new Date(c.end_play * 1000).format("hh:mm");
        c.course_type_name = enums.CouseType.getValue(c.course_type);
        let state = "";
        if (c.start_play > currentTime) {
          state = "未开始";
        } else if (c.start_play <= currentTime && c.end_play >= currentTime) {
          if (c.course_type == 7) {
            state = "正在上课";
          } else {
            state = "正在直播";
          }
        } else {
          state = "已结束";
        }
        c.state = state;
      });
      this.courses = courses;

      let otoCourses = data.otoCourseList;
      otoCourses.forEach(c => {
        c.start_play_time = new Date(c.start_play * 1000).format("hh:mm");
        c.end_play_time = new Date(c.end_play * 1000).format("hh:mm");
      });
      this.otoCourses = otoCourses;
    },
    async changeTab(current) {
      this.current = current;
      await this.getData();
    },
    async changeWeek(weekday) {
      this.weekday = weekday;
      await this.getData();
    }
  }
};
</script>
<style lang="scss" scoped>
.tab {
  overflow: hidden;
}

.tab-item {
  float: left;
  width: 178px;
  height: 56px;
  text-align: center;
  line-height: 56px;
  border: 1px solid #ddd;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.3s;
}

.tab-item-current {
  background-color: #ff9900;
  color: white;
  border-color: #ff9900;
}

.tab-content {
  padding-top: 30px;
}

.weekdates {
  overflow: hidden;
}

.weekdate {
  float: left;
  justify-content: center;
  text-align: center;
  width: 145px;
  height: 60px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid #d7d7d7;
  border-left: none;
  cursor: pointer;
}

.weekdate:first-child {
  border-left: 1px solid #d7d7d7;
}

.weekdate-current {
  background-color: #e4e4e4;
}

.type-title {
  font-size: 16px;
}

.course-item {
  display: flex;
  margin-bottom: 10px;
  height: 42px;
}

.course-time {
  padding: 0 60px;
}

.course-type {
  border: 1px solid #cccccc;
  color: #ff9900;
  line-height: 1;
  height: 14px;
  padding: 5px;
  box-sizing: content-box;
}

.course-title {
  font-size: 16px;
}

.course-teacher {
  width: 90px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.course-main {
  flex: 1;
  margin-left: 15px;
}

.course-state {
  margin: 0 100px;
}

.course-list {
  border: 1px solid #a9a9a9;
  padding-top: 10px;
  max-height: 315px;
  overflow-y: auto;
}

.sp-appoint-exam {
  width: 12px;
  height: 12px;
  display: inline-block;
  border: 1px solid #797979;
}

.sp-appoint-has {
  background-color: #ff9933;
  color: white;
}

.sp-appoint {
  border: 1px solid #797979;
  width: 80px;
  height: 30px;
  display: inline-block;
  text-align: center;
  line-height: 30px;
  margin-right: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>